const attivita = {

        hasZone: function (context) {
            return context.attivita
            && context.attivita.zone
            && context.attivita.zone.some(z => z.data && z.data.some(d => d.value > 0));
        },

        hasLaps: function (context) {
            const laps = context.attivita?.laps?.tabella?.laps;
            return !!(laps && laps.length);
        },

        labels: function (context, columns) {
            const headers = context.attivita?.laps?.tabella?.headers;
            if (!headers) {

                return [];
            }
            if (columns && columns.length) {

                return columns.map(c => headers[c]);
            }

            return headers;
        },

        laps: function (context, columns, columnsWithSuffix = []) {
            const laps = context.attivita?.laps?.tabella?.laps;
            if (!laps) {

                return [];
            }
            const suffixMap = {};
            if (columnsWithSuffix.length) {
                const fields = context.attivita?.laps?.grafico?.fields || [];
                fields.forEach(f => {
                    if (columnsWithSuffix.includes(f.key) && f.value_suffix) {
                        suffixMap[f.key] = f.value_suffix;
                    }
                });
            }

            const applySuffix = (key, value) => {
                const suffix = suffixMap[key];
                return (suffix && value != null && value !== '') ? `${value} ${suffix}` : value;
            };

            if (columns && columns.length) {
                return laps.map(l => columns.map(c => applySuffix(c, l[c])));
            }

            if (columnsWithSuffix.length) {
                return laps.map(l => {
                    const row = { ...l };
                    columnsWithSuffix.forEach(k => { row[k] = applySuffix(k, l[k]); });
                    return row;
                });
            }

            return laps;
        },
}

export default attivita;
